import React, { useEffect, useState } from 'react';
import TextField from '@material-ui/core/TextField';
import { Typography } from '@material-ui/core';
import MenuItem from '@material-ui/core/MenuItem';
import Grid from '@material-ui/core/Grid';

/* let startHours = [
  0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21,
  22, 23,
]; */
const marketPeriods = ['premarket', 'open', 'postmarket'];

const allHours = [
  0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20,
  21, 22, 23,
];
const preMarketHours = [8, 9];
const postMarketHours = [16, 17];
const regularMin = [
  0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21,
  22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40,
  41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59,
  60,
];
const first30Min = [
  0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21,
  22, 23, 24, 25, 26, 27, 28, 29, 30,
];
const last30Min = [
  30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48,
  49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60,
];
export default function StartPeriodHourMin({ top, dispatchTop }) {
  const [startHours, setStartHours] = useState([]);
  const [startMin, setStartMin] = useState([]);

  useEffect(() => {
    switch (top.startPeriod) {
      case 'open':
        setStartHours(allHours);
        setStartMin(regularMin);
        break;
      case 'premarket':
        setStartHours(preMarketHours);
        setStartMin(regularMin);

        break;
      case 'postmarket':
        setStartHours(postMarketHours);
        setStartMin(regularMin);
        break;
    }
  }, [top.startPeriod]);

  useEffect(() => {
    if (top.startHour === 9) {
      if (top.startPeriod === 'open') {
        setStartMin(regularMin);
      } else if (top.startPeriod === 'premarket') {
        setStartMin(first30Min);
      } else if (top.startPeriod === 'postmarket') {
        setStartMin(last30Min);
      }
    } else {
      setStartMin(regularMin);
    }
  }, [top.startHour]);
  const handleTimerPeriodChange = (ev) => {
    const newStartPeriod = ev.target.value;
    dispatchTop({ startPeriod: newStartPeriod });
    switch (newStartPeriod) {
      case 'open':
        dispatchTop({
          startHour: 9,
          startMin: 30,
        });
        break;
      case 'premarket':
        dispatchTop({
          startHour: 8,
          startMin: 0,
        });
        break;
      case 'postmarket':
        dispatchTop({
          startHour: 16,
          startMin: 0,
        });
        break;
      default:
        break;
    }
  };
  return (
    <>
      <Grid item container>
        <Grid item xs={1} />
        <Grid item xs={2}>
          <TextField
            id="outlined-select-currency"
            select
            size="small"
            label="timePeriod"
            value={top.startPeriod}
            onChange={handleTimerPeriodChange}
          >
            {marketPeriods.map((option) => (
              <MenuItem key={option} value={option}>
                {option}
              </MenuItem>
            ))}
          </TextField>
        </Grid>
        <Grid item xs={3}>
          <TextField
            select
            value={top.startHour}
            variant="outlined"
            size="small"
            style={{
              backgroundColor: 'white',
              //top.startHour === 9 && top.startMin === 30 ? 'white' : 'red',
              width: '100%',
            }}
            onChange={(ev) => dispatchTop({ startHour: ev.target.value })} //if starthour is 9 and open, only use backhalf of hour
            label={<Typography style={{ fontSize: 10 }}>Start hour</Typography>}
          >
            {startHours.map((option) => (
              <MenuItem key={option} value={option}>
                <Typography style={{ fontSize: 9 }}>{option}</Typography>
              </MenuItem>
            ))}
          </TextField>
        </Grid>
        <Grid item xs={3}>
          <TextField
            select
            value={top.startMin}
            variant="outlined"
            size="small"
            style={{
              backgroundColor: 'white',
              //top.startHour === 9 && top.startMin === 30 ? 'white' : 'red',
              width: '100%',
            }}
            onChange={(ev) => dispatchTop({ startMin: ev.target.value })}
            label={<Typography style={{ fontSize: 10 }}>Start min</Typography>}
          >
            {startMin.map((option) => (
              <MenuItem key={option} value={option}>
                <Typography style={{ fontSize: 9 }}>{option}</Typography>
              </MenuItem>
            ))}
          </TextField>
        </Grid>
      </Grid>
    </>
  );
}
